<template>
  <v-btn
    v-bind="useButtonStyle"
    :prepend-icon="mdiPlus"
    @click="createNewElement()"
  >
    {{ $t('mission-planning.qst.my-questionnaires.screen.element.add.btn') }}
  </v-btn>

</template>

<script setup>
import { inject } from 'vue';
import { mdiPlus } from '@mdi/js';
import { addNewElement } from '@/stores/manager/readingElementsManager';
import { READING } from '@/constants';
import { saveReadingCountersDebounced } from '@/stores/manager/conditionsManager';
import { createReadingIfNotExists } from "@/stores/manager/readingManager";
import {ConditionsController} from "@/utils/conditions/conditionsController";
import {useButtonStyle} from "@/utils/appStyleHandler";

const emit = defineEmits([
  'updateQuestionsConditions'
])

const currentMissionPlanningId = inject('currentMissionPlanningId');
const currentPointOfSale = inject('currentPointOfSale');
const currentConfiguration = inject('currentConfiguration');
const currentReadingId = inject('currentReadingId');
const userDetails = inject('userDetails');
const mission = inject('mission');
const configuration = inject('configuration');
const readingAnswers = inject('readingAnswers');

const createNewElement = async () => {
  await createReadingIfNotExists(
      currentReadingId.value,
      mission.value?.configuration?.id,
      currentMissionPlanningId.value || null,
      userDetails.value.id,
      currentConfiguration.value?.data || null
  );
  addNewElement(
    currentReadingId.value,
    userDetails.value?.id,
    currentMissionPlanningId,
    mission.value?.configuration?.id,
    configuration.value
  ).then((result) => {
    if (result !== false) {
      updateConditions(result);
    }
  });
}

const updateConditions = (readingElementId) => {
  let initialContext = {
    currentValue: null,
    answers: Object.values(readingAnswers.value).filter((ra) => ra.reading === currentReadingId.value),
    pos: currentPointOfSale.value,
    attachementType: READING.ATTACHMENT_TYPE.ELEMENT,
    attachementId: readingElementId,
    prod: null,
    nowDatetime: new Date()
  };

  const { questions } = new ConditionsController(currentConfiguration.value, initialContext, currentReadingId.value).createConditions()
  emit('updateQuestionsConditions', questions)
  saveReadingCountersDebounced(currentReadingId.value, currentConfiguration.value)
}

</script>